import { Component, OnInit } from "@angular/core";
import { WordlistService } from "../../core/services/wordlist.service";

@Component({
  selector: "app-advanced",
  templateUrl: "./html/sentences.html",
  styleUrls: [
    "../../assets/css/main.css",
    "../../assets/scss/fontawesome.scss",
    "../../assets/scss/brands.scss",
    "../../assets/scss/regular.scss",
    "../../assets/scss/solid.scss"
  ]
})
export class SentencesComponent implements OnInit {
  constructor(private Wordlist: WordlistService) {}
  ngOnInit() {}
}
